import htmlIcon from "../img/htmlIcon.png";
import cssIcon from "../img/cssIcon.png";
import sassIcon from "../img/sassIcon.png";
import jsIcon from "../img/jsIcon.png";
import reactIcon from "../img/reactIcon.png";
import nodejsIcon from "../img/nodejsIcon.png";
import typescriptIcon from "../img/typescriptIcon.png";

export const data = [
  {
    id: 1,
    name: "HTML",
    longName: "Hyper Text Markup Language",
    description: "Markup language for creating web pages.",
    image: htmlIcon,
    explaination:"HTML is a markup language used to create web pages. I studied HTML when I was studying at Telkom University. There I learned the basics of HTML taglines, and then until the 4th semester, I was still using HTML to make coursework assignments."
  },
  {
    id: 2,
    name: "CSS",
    longName: "Cascading Style Sheets",
    description: "Style sheet language for designing web pages.",
    image: cssIcon,
    explaination:"CSS is a style sheet language used to design web pages. I studied CSS when I was studying at Telkom University. There I learned the basics of CSS properties, and then until the 4th semester, I was still using CSS to make coursework assignments."
  },
  {
    id: 3,
    name: "Sass",
    longName: "Syntactically Awesome Style Sheets",
    description: "Syntactically Awesome Stylesheet",
    image: sassIcon,
    explaination:"Sass is a style sheet language used to design web pages.I learned Sass when I worked at my first company, I studied independently with my basic CSS skills and got help from the internet. in this portfolio I also made it with Sass"
  },
  {
    id: 4,
    name: "JavaScript",
    description: "Programming language for adding interactivity to web pages.",
    image: jsIcon,
    explaination:"JavaScript is a programming language used to create interactive web applications.I first learned JavaScript in college but it wasn't in the course so I studied independently and only a little. I learned a lot of JavaScript when I started my internship and work, then I was interested in attending a bootcamp where the basics were using JavaScript"
  },
  {
    id: 5,
    name: "TypeScript",
    description: "Superset of JavaScript with static typing.",
    image: typescriptIcon,
    explaination:"TypeScript is a superset of JavaScript with static typing. I got to know Typescript when I was an intern after learning the basics of JavaScript. there I learned typescript but not as deeply as I studied javascript"
  },
  {
    id: 6,
    name: "React",
    description: "JavaScript library for building user interfaces.",
    image: reactIcon,
    explaination:"React is a JavaScript library used to build dynamic and interactive user interfaces (UI) or web applications. I first used ReactJs when I was involved in my internship project, in that office I used React for work where React used Typescript templates"
  },
  {
    id: 7,
    name: "Node JS",
    description: "JavaScript runtime environment for server-side development.",
    image: nodejsIcon,
    explaination:"Node.js is a JavaScript runtime environment used for server-side development. I used nodejs when I worked at my first company as a full-time software engineer. Apart from that, I use node js a lot as the back-end in my bootcamp"
  },
];
